import { PayloadAction } from '@reduxjs/toolkit';
import { DICTIONARY_ENTITY_NAME } from 'typings/subEntities/dictionaries/dictionaries.enum';
import SliceFactory from './SliceFactory';

const initialState = {
  [DICTIONARY_ENTITY_NAME.wareCategory]: {
    isLoading: false,
    wareCategoryList: [] as WareCategory[],
  },
  [DICTIONARY_ENTITY_NAME.orderContractType]: {
    isLoading: false,
    orderContractTypeList: [] as OrderContractType[],
  },
  [DICTIONARY_ENTITY_NAME.distributionCity]: {
    isLoading: false,
    distributionCityList: [] as DistributionCity[],
  },
  [DICTIONARY_ENTITY_NAME.promotionsDictionary]: {
    isLoading: false,
    promotionsDictionaryList: [] as PromotionsDictionary[],
  },
  [DICTIONARY_ENTITY_NAME.recommendationsDictionary]: {
    isLoading: false,
    recommendationsDictionaryList: [] as RecommendationsDictionary[],
  },
  [DICTIONARY_ENTITY_NAME.measurementUnitDictionary]: {
    isLoading: false,
    measurementUnitDictionaryList: [] as MeasurementUnitDTO[],
  },
};

const dictionariesSlice = SliceFactory.createSimpleSlice({
  name: 'dictionaries',
  initialState,
  reducers: {
    setList(state, action: PayloadAction<{ name: DICTIONARY_ENTITY_NAME; list: any[] }>) {
      const { list, name } = action.payload;
      (state[name] as any)[name + 'List'] = list;
    },
    startLoading(state, action: PayloadAction<DICTIONARY_ENTITY_NAME>) {
      state[action.payload].isLoading = true;
    },
    stopLoading(state, action: PayloadAction<DICTIONARY_ENTITY_NAME>) {
      state[action.payload].isLoading = false;
    },
    resetData(state, action: PayloadAction<DICTIONARY_ENTITY_NAME>) {
      (state[action.payload] as any) = initialState[action.payload];
    },
  },
});

export default dictionariesSlice;
